import { ButtonBase, Tooltip, Typography } from "@mui/material";
import { Popover } from "antd";
import { useEffect, useState } from "react";

const SwitchBox = (props) => {
  const { title, tabs, info, value } = props;
  // console.log("ALL VALUE", value);
  const [tabIdx, setTabIdx] = useState(0);
  let infoText = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <ul className="pl-[15px]">
        <li className="list-disc text-[12px]">Very High (81 - 100%)</li>
        <li className="list-disc text-[12px]">High (71 - 80%)</li>
        <li className="list-disc text-[12px]">Normal (60 - 70%)</li>
      </ul>
      <p className="my-[7px] text-[12px]">
        *LTV Approval is for reference only and on a case-to-case basis. LTV
        Approval above 80% may include Rental, Private Hire Loan nad
        Lease-to-own loan packages
      </p>
    </div>
  );
  let infoText2 = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <ul className="pl-[15px]">
        <li className="list-disc text-[12px]">Instant &lt; 30 Minutes</li>
        <li className="list-disc text-[12px]">Fast &lt; 2 Working Days</li>
        <li className="list-disc text-[12px]">Very Fast &lt; 1 Working Day</li>
      </ul>
      <p className="my-[7px] text-[12px]">
        *Approval Time is for reference only and on straightforward loan cases.
        Approval Time is calculated based on the time needed to approve or
        reject a loan application submission
      </p>
    </div>
  );
  let infoText3 = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <p className="my-[7px] text-[12px]">
        Bonus are extra incentives for getting a loan from the particular loan
        provider. Check loan bonus details for more information on eligibility,
        criteria(s) and payout period(s).
      </p>
    </div>
  );
  let tootipText = "";
  if (title === "Approval Time") {
    tootipText = infoText2;
  } else if (title === "Loan to Value") {
    tootipText = infoText;
  } else if (title === "Bonus") {
    tootipText = infoText3;
  } else {
    tootipText = "coming soon";
  }
  const handleSwitch = (idx, tabId) => {
    setTabIdx(idx);
    if (props.settingsHandle) {
      let titleName = title.toLowerCase();
      if (titleName == 'category') {
        titleName = 'type';
      } else if (titleName == 'type') {
        titleName = 'category';
      }
      props.settingsHandle(idx, titleName, tabId);
    }
  };
  useEffect(() => {
    setTabIdx(0);
  }, [tabs]);
  return (
    <div className={`switch_tab mr-[20px] mb-[15px] inline-block`}>
      <label className="text-[13px] text-[#878B91] mb-[10px] inline-flex items-center">
        {title && title}
        {info && (
          <Popover content={tootipText} placement="bottom">
            <img
              src="/images/fi_info.svg"
              alt="info"
              className="inline-block ml-[8px] cursor-pointer"
            />
          </Popover>
        )}
      </label>
      <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
        {/* {console.log("SWITCH", tabs)} */}

        {tabs.map((tab, idx) => {
          return (
            <ButtonBase key={idx} disabled={tab?.disabled ? true : false}>
              <span
                className={`switch ${value !== undefined
                  ? value === tab?.id && "active"
                  : tabIdx === idx && "active"
                  }`}
                onClick={() => handleSwitch(idx, tab.id)}
              >
                {tab?.name}
              </span>
            </ButtonBase>
          );
        })}
      </div>
    </div>
  );
};

export default SwitchBox;
